export enum StockPeriods {
  ONE_MINUTE = 'ONE_MINUTE',
  TWO_MINUTES = 'TWO_MINUTES',
  THREE_MINUTES = 'THREE_MINUTES',
  FIVE_MINUTES = 'FIVE_MINUTES',
  TEN_MINUTES = 'TEN_MINUTES',
  FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
  HALF_HOUR = 'HALF_HOUR',
  ONE_HOUR = 'ONE_HOUR',
  DAILY = 'DAILY',
  YEAR = 'YEAR',
  WEEKLY = 'WEEKLY'
}
